export const { REACT_APP_DATA_EXPIRE_AFTER: DATA_EXPIRE_AFTER } = process.env;
export const NO_CURRENT_ENTITY = null;
